import { HttpInterceptorFn } from '@angular/common/http';

export const timeZoneInterceptor: HttpInterceptorFn = (req, next) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const clonedRequest = req.clone({
    setHeaders: {
      timeZone,
    },
  });

  return next(clonedRequest);
};
